export const IsStringNotEmptyValidator = (value: string | undefined | null, message: string): ValidationResult => {
    if (!value) {
        return { passed: false, error: message };
    }
    const isValueCorrect = !!value.trim().length;
    return {
        passed: isValueCorrect,
        error: isValueCorrect ? "" : "Provided value is incorrect",
    };
};

interface ValidationResult {
    error: string;
    passed: boolean;
}

export type { ValidationResult };
